import { RefObject } from "react";
import { Token } from "../theme";

interface Props {
  height?: string;
  topSection: JSX.Element;
  bottomSection: JSX.Element;
  bottomSectionRef?: RefObject<HTMLDivElement>;
}

export const AppContainerFullHeight = ({ height = "100vh", topSection, bottomSection, bottomSectionRef }: Props) => {
  return (
    <div style={{ display: "flex", flex: "0 1 auto", flexFlow: "column", gap: Token.cardPad, height: "calc(100vh - 128px)" }}>
      <div>{topSection}</div>
      <div ref={bottomSectionRef} style={{ flex: "1 1 auto" }}>
        {bottomSection}
      </div>
    </div>
  );
};
